import { render, staticRenderFns } from "./CompanyCorrAddress.vue?vue&type=template&id=4b8f508f&scoped=true&"
import script from "./CompanyCorrAddress.vue?vue&type=script&lang=js&"
export * from "./CompanyCorrAddress.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCorrAddress.vue?vue&type=style&index=0&id=4b8f508f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f508f",
  null
  
)

export default component.exports